'use strict';
/*jshint -W099*/
/* Services */

// URL to api server for testing at xentex
//var api_server = 'http://app.xntxvm.com:8080';
// For Production this server is a relative path so just make it blank
// var api_server = '/main/v1'; - use api_server instead (!!)

var services = angular.module('client.services', [
  'ngResource',
  'angularFileUpload',
  'configuration',
  'ngCookies',
  'UtilsModule'
]);

/*
 function iPadDidRotateToLandscapeOrientation( width, height ) {
 var appScope = angular.element($("#layout")).scope();
 appScope.maxwidth = width;
 }

 function iPadDidRotateToPortraitOrientation( width, height ) {
 var appScope = angular.element($("#layout")).scope();
 appScope.maxwidth = width;
 }
 */

services.factory('beforeUnload', ['$rootScope', '$window',
  function ($rootScope, $window) {
    $window.onbeforeunload = function (e) {
      var confirmation = {};
      var event = $rootScope.$broadcast('onBeforeUnload', confirmation);
      if (event.defaultPrevented) {
        return confirmation.message;
      }
    };

    $window.onunload = function () {
      $rootScope.$broadcast('onUnload');
    };
    return {};
  }])
  .run(function (beforeUnload) {
    // Must invoke the service at least once
  });

//----------------------------------------------------------
//
// Keeps the logged in user information for subsequent calls to the API and for optional UI display based on user type
//
// ----------------------------------------------------------
services.factory('User', ['$rootScope', '$cookies', '$sessionStorage', '$localStorage',
  '$log', 'token_cookie_name', 'SegmentFactory', '$q', '$location',
  function ($rootScope, $cookies, $sessionStorage, $localStorage,
            $log, token_cookie_name, SegmentFactory, $q, $location) {
    var ROLE = Object.freeze({TEACHER: 'TEACHER', STUDENT: 'STUDENT', NONE: 'NONE'});
    var userData = {};
    var role = ROLE.NONE;

    var sessionToken = null;

    var hasLoggedDeffered = $q.defer();
    var hasLoggedFlag = false;

    return {
      getCurrentUser: function getCurrentUser() {
        return userData;
      },
      setCurrentUser: function setCurrentUser(user) {
        userData = user;
        $rootScope.$emit('USER.updated', user);
        role = (userData.system_role || '').toUpperCase();

        // Send Segment `identify' event and manually initialize Intercom messenger for non-students
        if (role !== ROLE.STUDENT && role !== ROLE.NONE) {
          SegmentFactory.identify(userData);
        }
        return user;
      },
      markAsLoggedIn: function markAsLogged() {
        hasLoggedFlag = true;
        hasLoggedDeffered.resolve(true);
      },
      getSessionToken: function getSessionToken() {
        return sessionToken;
      },
      setSessionToken: function setSessionToken(token) {
        $localStorage[token_cookie_name] = token;
        sessionToken = token;
        return sessionToken;
      },
      getId: function getId() {
        return userData.id;
      },
      logout: function logoutUser() {
        $log.info("User.logout()");

        $localStorage[token_cookie_name] = null;
        $cookies.remove(token_cookie_name, {path: "/"});
        $cookies.remove(token_cookie_name, {path: "/", domain: '.exploros.com'});
        $cookies.remove(token_cookie_name);
        $cookies.remove('api_uid');

        userData = {};

        role = ROLE.NONE;

        sessionToken = null;

        SegmentFactory.disconnect();

        hasLoggedFlag = false;
        hasLoggedDeffered.reject('logout');
        hasLoggedDeffered = $q.defer();

        $sessionStorage.$reset();
      },
      hasToken: function hasToken() {
        return !!$localStorage[token_cookie_name] || !!$location.search().token;
      },
      getSystemRole: function getSystemRole() {
        return (userData.system_role || '').toUpperCase();
      },
      isTeacher: function isTeacher() {
        return this.getSystemRole() === ROLE.TEACHER;
      },
      isStudent: function isStudent() {
        return this.getSystemRole() === ROLE.STUDENT;
      },
      isTextToSpeechEnabled: function isTextToSpeechEnabled() {
        return role === ROLE.STUDENT && userData.accessibility_options === true;
      },
      isGoogleUser: function isGoogleUser() {
        return userData.google_user;
      },
      isCanvasUser: function isCanvasUser() {
        return userData.canvas_user;
      },
      hasLoggedIn: function hasLoggedIn() {
        return hasLoggedDeffered.promise;
      },
      getStateId: function getStateId() {
        return userData.state_id;
      },
      ROLE: ROLE
    };
  }]);


services.factory('SessionErrorInterceptor', ['$location', '$rootScope', '$injector', '$q', '$log', '$localStorage', 'token_cookie_name',
  function ($location, $rootScope, $injector, $q, $log, $localStorage, token_cookie_name) {
    return {
      'request': function (config) {
        $log.debug("Requesting " + config.url);
        var sessionToken = $localStorage[token_cookie_name];
        if (sessionToken && config.url && config.url.indexOf('/main/v1') !== -1) {
          config.headers = config.headers || {};
          if (!config.headers.Authorization) {
            config.headers.Authorization = 'Bearer ' + sessionToken;
          }
        }
        return config;
      },
      'requestError': function (rejection) {
        $log.debug("requestError:  ", rejection);
        return $q.reject(rejection);
      },
      'responseError': function (rejection) {
        $log.debug("responseError: ", rejection);
        return $q.reject(rejection);
      },
      'response': function (response) {
        if (response.data && response.data.error && response.data.error.type === 'session_error') {
          const requestAuthorization = response.config?.headers?.Authorization;
          const savedToken = $localStorage[token_cookie_name];
          if ((response.config && response.config.skipSessionErrorLogout) ||
            (requestAuthorization && savedToken && requestAuthorization !== 'Bearer ' + savedToken)) {
            return $q.reject(response.data.error);
          }
          return $injector.get('loginService').logout()
            .then(function () {
              return $q.reject(response.data.error);
            });
        }
        return response;
      }
    };
  }]);

services.config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push('SessionErrorInterceptor');
  $httpProvider.defaults.withCredentials = true;
}]);

services.factory('PageService', ['$rootScope', '$route', function ($rootScope, $route) {
  var service = {};
  var pageData = {};
  pageData.teacherCode = '';
  pageData.teacherFullname = '';
  pageData.bodyClass = '';
  pageData.navView = '';
  pageData.mainClass = 'restricted-width';

  service.activatePage1 = function () {
    $rootScope.$broadcast("page1Activated");
  };

  service.activatePage2 = function (teacherCode, teacherFullname) {
    pageData.teacherCode = teacherCode;
    pageData.teacherFullname = teacherFullname;
    $rootScope.$broadcast("page2Activated");
  };

  service.activatePage3 = function () {
    $rootScope.$broadcast("page3Activated");
  };
  // Share this
  service.getTeacherCode = function () {
    return pageData.teacherCode;
  };
  service.getTeacherName = function () {
    return pageData.teacherFullname;
  };

  service.getBodyClass = function () {
    return pageData.bodyClass;
  };

  service.getMainClass = function () {
    return pageData.mainClass;
  };

  service.getNavView = function () {
    return pageData.navView;
  };

  service.updateNavView = function (navView) {
    pageData.navView = navView;
    $rootScope.$broadcast("navViewUpdated", {navView: pageData.navView});
    return pageData.navView;
  };

  service.updateBodyClass = function (route) {
    if (route && route.redirectTo) {
      return;
    }
    pageData.bodyClass = (route && route.$$route && route.$$route.bodyClass) ? route.$$route.bodyClass : '';
    $rootScope.$broadcast("pageBodyClassUpdated", {bodyClass: pageData.bodyClass});
    return pageData.bodyClass;
  };

  service.updateMainClass = function (route) {
    if (route && route.redirectTo) {
      return;
    }
    pageData.mainClass = (route && route.$$route && route.$$route.mainClass) ? route.$$route.mainClass : 'restricted-width';
    $rootScope.$broadcast("pageMainClassUpdated", {mainClass: pageData.mainClass});
    return pageData.mainClass;
  };

  return service;
}]);

services.factory('InvalidateSessionFactory', ['api_server', '$resource', function (api_server, $resource) {
  var url = api_server + '/invalidate/:token';

  return $resource(url, {token: '@token'}, {
    invalidate: {method: 'DELETE', params: {token: '@token'}}
  });
}]);

services.factory('LoginFactory', ['api_server', '$resource', function (api_server, $resource) {
  var url = api_server + '/session/:action';

  return $resource(url, {}, {
    login: {method: 'POST', params: {action: 'login'}},
    logout: {method: 'GET', params: {action: 'logout'}},
    validate: {method: 'POST', params: {action: 'validate'}},
    heartbeat: {method: 'GET', params: {action: 'heartbeat'}}
  });
}]);

services.factory('TaoTestService', ['api_server', '$resource', function (api_server, $resource) {
  var url = api_server + '/taoResults/:eid';

  return $resource(url, {eid: '@eid'}, {
    getTestResults: {method: 'GET', params: {eid: '@eid'}}
  });
}]);

services.factory('EventAuditAnalyticsService', ['api_server', '$resource', function (api_server, $resource) {
  var url = api_server + '/analytics/put';

  return $resource(url, {}, {
    save: {method: 'PUT'}
  });
}]);

services.factory('PresenceValidator', ['$interval', '$timeout', '$window', '$log',
  'loginService', 'ModalService', 'User', 'UserLastActive', '$location', 'logoutService', 'WebSocket',
  function ($interval, $timeout, $window, $log, loginService, ModalService, User, UserLastActive, $location, logoutService, WebSocket) {
    var interval = null;
    var in_timeout = false;

    return {
      start: function () {
        UserLastActive.set();
        if (interval) {
          $interval.cancel(interval);
        }
        interval = $interval(function () {
          const currentPath = $location.path();
          if (currentPath === '/signup' || currentPath.indexOf('/signup/') === 0) {
            return;
          }
          if (!User.getCurrentUser()) {
            return;
          }
          if (in_timeout) {
            return;
          }
          var lastActiveTime = UserLastActive.get();
          var allowedInnactivityTime = Date.now() - 2 * 60 * 60 * 1000;
          if (allowedInnactivityTime < lastActiveTime) {
            return;
          }
          in_timeout = true;

          WebSocket.disconnect(WebSocket.CLOSE_REASONS.TIMEOUT);
          logoutService.logOutByTimeout().catch(function (error) {
            $log.error('Failed to complete inactivity cleanup.', error && error.status);
          });

          // It is possible that we already have a modal open when we received this error.
          // We want to therefore close all existing modals before we show this one.
          ModalService.hideAll();

          ModalService.show({
            message: 'The connection to Exploros has timed out due to inactivity.',
            backdrop: 'static',
            buttons: [
              {
                title: 'OK',
                click: 'refreshPage(); $hide();'
              }
            ],
            refreshPage: function () {
              $timeout(function () {
                in_timeout = false;
                $window.location.reload();
              });
            }
          });


        }, 5000);
      },
      stop: function () {
        if (interval) {
          $interval.cancel(interval);
        }
      }
    };
  }]);

services.factory('UserInfoDefaultFactory', ['$resource', '$rootScope', 'User', 'api_server',
  function ($resource, $rootScope, User, api_server) {
    var url = api_server + '/users/:id';

    function cacheUser(user) {
      user = angular.fromJson(user);
      return user;
    }

    return $resource(url,
      {
        id: '@id',
        school_id: '@school_id'
      },
      {
        get: {
          method: 'GET',
          params: {
            id: '@id'
          },
          transformResponse: cacheUser
        },
        save: {
          method: 'PUT',
          transformResponse: cacheUser
        },
        saveSchool: {
          url: url + '/school/:school_id',
          method: 'PUT',
          params: {
            id: '@id',
            school_id: '@school_id'
          },
          transformResponse: cacheUser
        },
        deleteLms: {
          method: 'DELETE',
          url: url + '/ims/:ims',
          params: {
            id: '@id',
            ims: '@ims'
          }
        }
      }
    );
  }]);

services.factory('UserInfoProfileFactory', ['api_server', '$resource', function (api_server, $resource) {
  var url = api_server + '/users/:id/profile';
  return $resource(url, {id: '@id'}, {
    get: {method: 'GET', params: {id: '@id'}}
  });
}]);

services.factory('UserInfoSettingsFactory', ['api_server', '$resource', function (api_server, $resource) {
  var url = api_server + '/users/:id/settings';
  return $resource(url, {id: '@id'}, {
    get: {method: 'GET', params: {id: '@id'}}
  });
}]);

services.factory('UserPhotoFactory', ['api_server', '$resource', function (api_server, $resource) {
  var url = api_server + '/users/:id/photo/:action';
  return $resource(url, {id: '@id'}, {
    remove: {method: 'PUT', params: {id: '@id', action: 'remove'}}
  });
}]);

services.factory('UserCodeFactory', ['api_server', '$resource', function (api_server, $resource) {
  var url = api_server + '/local_groups/:id/get_code';
  return $resource(url, {id: '@id'}, {
    get: {method: 'GET', cache: true, params: {id: '@id'}}
  });
}]);

services.factory('UserPasswordSettingsFactory', ['api_server', '$resource', function (api_server, $resource) {
  var url = api_server + '/users/:id/password';
  return $resource(url, {id: '@id'}, {
    update: {method: 'PUT', params: {id: '@id'}}
  });
}]);

services.factory('UserPresence', ['api_server', '$resource', function (api_server, $resource) {
  var url = api_server + '/users/online';
  return $resource(url, {id: '@id', experience_id: '@experienceId'}, {
    present: {method: 'POST', isArray: true, params: {id: '@id', experience_id: '@experienceId'}}
  });
}]);

services.factory('ActiveExperienceService', ['$sessionStorage', 'ActivityStateFactory', '$q', '$log', function ($sessionStorage, ActivityStateFactory, $q, $log) {
  var USER_SCENE_KEY = 'scene';
  var USER_SCENE_COUNT_KEY = 'scene_count';
  var cachedUserId = 0;
  var cachedExperienceId = 0;
  var cachedSceneIndex = 0;
  var defaultDashboard = "responses";

  return {
    getScene: function (userid, experienceId) {
      var deferred = $q.defer();

      ActivityStateFactory.get({}, {'id': experienceId, 'user_id': userid}, function (state) {
        var lastScene = 0;
        if (state && state.current_scene_id) {
          lastScene = Number(state.current_scene_id);
        }
        deferred.resolve(lastScene);
      });
      return deferred.promise;
    },
    setScene: function (userid, experienceId, value) {
      ActivityStateFactory.get({}, {'id': experienceId, 'user_id': userid}, function (state) {
        if (!state) {
          state = {};
        }
        state.current_scene_id = value;
        ActivityStateFactory.post({}, {
          'id': experienceId,
          'user_id': userid,
          'current_scene_id': value
        }, function (result) {

        });
      });

    },
    getLastScene: function (userid, experienceid) {
      if (cachedUserId == userid && cachedExperienceId == experienceid) {
        return cachedSceneIndex;
      } else {
        return 0;
      }
    },
    setLastScene: function (userid, experienceid, sceneIndex) {
      cachedUserId = userid;
      cachedExperienceId = experienceid;
      cachedSceneIndex = sceneIndex;
    },
    getSceneCount: function (userid, experienceid) {
      var sceneCountKey = USER_SCENE_COUNT_KEY + "_" + userid + "_" + experienceid;
      var cookieSceneCount = $sessionStorage[sceneCountKey];
      if (cookieSceneCount) {
        return cookieSceneCount;
      } else {
        return 0;
      }
    },
    setSceneCount: function (userid, experienceid, sceneCount) {
      var sceneCountKey = USER_SCENE_COUNT_KEY + "_" + userid + "_" + experienceid;
      if (sceneCount === 0) {
        delete $sessionStorage[sceneCountKey];
      } else {
        $sessionStorage[sceneCountKey] = sceneCount;
      }
      return this.getSceneCount(userid, experienceid);
    },
    setDashboard: function (dashboard) {
      defaultDashboard = dashboard;
    },
    getDashboard: function () {
      return defaultDashboard;
    }
  };
}]);

services.factory('ExperienceNavigator', ['$sessionStorage', '$location',
  function ($sessionStorage, $location) {
    var isPreview = false;

    function setBackDestination(destination, query) {
      if (angular.isUndefined(destination)) {
        delete $sessionStorage.experienceBackDestination;
        delete $sessionStorage.experienceBackDestinationQuery;
      } else {
        $sessionStorage.experienceBackDestination = destination;
        if (query) {
          $sessionStorage.experienceBackDestinationQuery = query;
        }
      }
    }

    function navigateToExperience(path, query, backPath, backQuery) {
      setBackDestination(backPath, backQuery);
      $location.path(path).search(query);
    }

    function getBackDestination() {
      return $sessionStorage.experienceBackDestination;
    }

    function getBackDestinationQuery() {
      return $sessionStorage.experienceBackDestinationQuery || {};
    }

    function setPreview(userInPreview) {
      isPreview = userInPreview;
    }

    function getPreview() {
      return isPreview;
    }

    return {
      setBackDestination: setBackDestination,
      getBackDestination: getBackDestination,
      getBackDestinationQuery: getBackDestinationQuery,
      navigateToExperience: navigateToExperience,
      setPreview: setPreview,
      getPreview: getPreview
    };

  }]);

services.factory('ThemeService', function () {
  var theme = 'exploros';
  return {
    getTheme: function () {
      return theme;
    },
    setTheme: function (newTheme) {
      theme = newTheme;
    },
    getIconPath: function () {
      return "themes/" + theme + "/icons/icons.svg";
    }
  };
});

services.factory('SegmentFactory', ['segment', 'segmentLoader', 'IntercomFactory', '$log', '$resource', '$q', 'LicensePlans', 'api_server', '$timeout',
  function (segment, segmentLoader, IntercomFactory, $log, $resource, $q, LicensePlans, api_server, $timeout) {

    var log = $log;
    var EVENTS = {};

    function allowIntercom(userInfo) {
      var role = (userInfo.system_role || '').toUpperCase();
      var blacklistedRoles = ['STUDENT', 'NONE'];
      
      if (blacklistedRoles.indexOf(role) >= 0) {
        return $q.reject('Analytics not allowed for ' + role);
      }

      return LicensePlans.getAssignable({'userId': userInfo.id}).$promise.then(function (result) {
        var hasNonEPSLicense = true;
        if (result.length) {
          hasNonEPSLicense = false;
          result.forEach(function (license) {
            if (license.plan_token.toLowerCase() !== 'spire' &&
              license.plan_token.toLowerCase() !== 'ispire' &&
              license.plan_token.toLowerCase() !== 'wordlywise') {
              hasNonEPSLicense = true;
            }
          });
        }
        return hasNonEPSLicense;
      });
    }

    (function getEvents() {
      var url = api_server + '/analytics/events';
      $resource(url).get().$promise
        .then(function (events) {
          EVENTS = events;
        })
        .catch(function () {
          log.error('Error retrieving Segment events list');
        });
    })();

    function events() {
      return EVENTS;
    }

    function getApiKey() {
      var url = api_server + '/config/analytics/segment';
      return $resource(url).get().$promise;
    }

    function onReady(user) {
      if (user) {
        IntercomFactory.init();
      }
    }

    function disconnect() {
      IntercomFactory.shutdown();
    }

    function onTrack() {
      IntercomFactory.update();
    }

    function track(event, properties, options, callback) {
      log.debug('Calling Segment track event ' + angular.toJson(event));
      segment.track(event, properties, options, callback);
      if (callback) {
        callback();
      }
      onTrack();
    }

    function group(groupId, traits, options, callback) {
      log.debug('Calling Segment group event ' + angular.toJson(groupId));
      segment.group(groupId, traits, options, function () {
        if (callback) {
          callback();
        }
        onTrack();
      });
    }

    function identify(user) {
      return allowIntercom(user).then(function (show) {
        return getApiKey().then(function (analyticsCredenetials) {
          log.debug('Analytics Credentials', analyticsCredenetials);
          
          if (!window.analytics || (window.analytics && !window.analytics.initialized)) {
            log.debug('Loading Segment');
            segmentLoader.load(analyticsCredenetials.key);
          }

          var role = (analyticsCredenetials.system_role || '').toUpperCase();
          if (window.analytics) {
            $timeout(function () {
              try {
                log.debug('Calling Segment identify()');
                segment.identify(analyticsCredenetials.user_id, {role: role}, {
                  Intercom: {
                    user_hash: analyticsCredenetials.user_hash,
                    hideDefaultLauncher: !show
                  }
                });
              } catch (e) {
                log.error('Error calling Segment identify()', e);
              }
            }, 0);
          }
        })
          .catch(function (e) {
            log.error('Error retrieving Segment API Key', e);
            throw e;
          });
      })
        .catch(function (e) {
          log.debug('Analytics not allowed:', e);
        });
    }

    function reset() {
      segment.reset();
      IntercomFactory.shutdown();
    }

    return {
      events: events,
      onReady: onReady,
      disconnect: disconnect,
      onTrack: onTrack,
      track: track,
      group: group,
      identify: identify,
      reset: reset
    };
  }]);

services.factory('IntercomFactory', ['$log', '$timeout', '$resource', 'api_server',
  function ($log, $timeout, $resource, api_server) {

    function getAppId() {
      var url = api_server + '/config/analytics/intercom';
      return $resource(url).get().$promise;
    }

    function init() {
      if (window.Intercom) {
        getAppId()
          .then(function (userConfig) {
            window.Intercom('boot', userConfig);
          })
          .catch(function () {
            $log.error('Error retrieving Intercom App ID');
          });
      }
    }

    function update() {
      if (window.Intercom) {
        $timeout(function () {
          window.Intercom('update');
          $log.debug('Updating Intercom panel');
        }, 500);
      }
    }

    function shutdown() {
      if (window.Intercom) {
        window.Intercom('shutdown');
      }
    }

    return {
      init: init,
      shutdown: shutdown,
      update: update
    };
  }]);

services.service('GoogleAnalytics', ['$location', '$rootScope', '$window', function ($location, $rootScope, $window) {
  return {
    init: function () {
      $rootScope.$on('$viewContentLoaded', function (event) {
        $window.ga('send', 'pageview', {page: $location.absUrl()});
      });
    }
  };
}]);

//----------------------------------------------------------
//
// Used to retrieve all master templates for the specified teacher
//
// ----------------------------------------------------------
services.factory('TeacherMasterFactory', ['api_server', '$resource', function (api_server, $resource) {
  // works
  var url = api_server + '/catalog/purchased';
  return $resource(url, {user_id: '@user_id'}, {
    masters: {method: 'GET', isArray: true, params: {user_id: '@user_id'}}
  });
}]);

//----------------------------------------------------------
//
// Used to retrieve particular master templates
//
// ----------------------------------------------------------
services.factory('MasterFactory', ['api_server', '$resource', function (api_server, $resource) {
  // works
  var url = api_server + '/experience_templates/:template_id/collection/:collection/assignment';
  return $resource(url, {template_id: '@template_id'}, {
    master: {method: 'GET', params: {template_id: '@template_id', collection: '@collection'}}
  });
}]);

services.factory('CollectionsFactory', ['api_server', '$resource', function (api_server, $resource) {
  var url = api_server + '/experiences/';
  return $resource(url, {}, {
    assignableClasses: {url: url + 'classes/check-assignable', method: 'POST', isArray: true}
  });
}]);

services.factory('ForgotPasswordFactory', ['api_server', '$resource',
  function (api_server, $resource) {
    var url = api_server + '/users/reset';
    return $resource(url, {}, {
      post: {method: 'POST'}
    });
  }]);

services.factory('ConnectToTeacherValidateFactory', ['api_server', '$resource',
  function (api_server, $resource) {
    // works
    var url = api_server + '/local_groups/:code/validate_code';
    return $resource(url, {code: '@code'}, {
      get: {method: 'GET', params: {code: '@code'}}
    });
  }]);

services.factory('UserSignupFactory', ['api_server', '$resource',
  function (api_server, $resource) {
    // works
    var url = api_server + '/users';
    return $resource(url, {
      email: '@email',
      username: '@username',
      password: '@password',
      first_name: '@first_name',
      last_name: '@last_name',
      system_role: '@system_role',
      classId: '@classId'
    }, {
      post: {
        method: 'POST', params: {
          email: '@email',
          username: '@username',
          password: '@password',
          first_name: '@first_name',
          last_name: '@last_name',
          system_role: '@system_role',
          classId: '@classId'
        }
      }
    });
  }]);

services.factory('GoogleOauthUrlFactory', ['api_server', '$resource', '$http', '$location',
  function (api_server, $resource, $http, $location) {
    // works
    var url = api_server;
    var application_id = $http.defaults.headers.common.application_id;

    return $resource(url, {
      system_role: '@system_role',
      classCode: '@classCode',
      application_id: application_id
    }, {
      signup: {
        method: 'GET',
        url: api_server + '/auth/google/url/signup',
        params: {
          system_role: '@system_role',
          classCode: '@classCode',
          application_id: application_id,
          app_url: $location.protocol() + '://' + window.location.host
        },
        transformResponse: function (data) {
          //Getting string data in response
          return angular.fromJson(data);
        }
      }
    });
  }]);

services.factory('CleverOauthUrlFactory', ['api_server', '$resource', '$http', '$location',
  function (api_server, $resource, $http, $location) {
    // works
    var url = api_server;
    var application_id = $http.defaults.headers.common.application_id;

    return $resource(url, {
      system_role: '@system_role',
      classCode: '@classCode',
      application_id: application_id
    }, {
      signup: {
        method: 'GET',
        url: api_server + '/auth/clever/signup',
        params: {
          system_role: '@system_role',
          classCode: '@classCode',
          application_id: application_id,
          app_url: $location.protocol() + '://' + window.location.host
        },
        transformResponse: function (data) {
          //Getting string data in response
          return angular.fromJson(data);
        }
      }
    });
  }]);

services.factory('ConnectToTeacherFactory', ['api_server', '$resource', function (api_server, $resource) {
  //  At this point, user is logged in now, connect student logged in user to teacher
  var url = api_server + '/local_groups/:code/connect_to_teacher';
  return $resource(url, {code: '@code'}, {
    get: {method: 'GET', params: {code: '@code'}}
  });
}]);

services.factory('ExperienceClassGroupFactory', ['api_server', '$resource', function (api_server, $resource) {
  //  At this point, user is logged in now, connect student logged in user to teacher
  var url = api_server + '/local_groups/:id/class/:cid/groups';
  return $resource(url, {
    id: '@id',
    cid: '@cid'
  }, {
    get: {
      method: 'GET',
      params: {
        id: '@id',
        cid: '@cid'
      }
    }
  });
}]);


services.factory('ExperienceGroupListFactory', ['api_server', '$resource', function (api_server, $resource) {
  //  At this point, user is logged in now, connect student logged in user to teacher
  var url = api_server + '/local_groups/:id/group/:gid/students';
  return $resource(url, {
    id: '@id',
    gid: '@gid'
  }, {
    get: {
      method: 'GET',
      params: {
        id: '@id',
        gid: '@gid'
      }
    }
  });
}]);

services.factory('ExperienceClassFactory', ['api_server', '$resource', function (api_server, $resource) {
  //  At this point, user is logged in now, connect student logged in user to teacher
  var url = api_server + '/experiences/:id/class';
  return $resource(url, {id: '@id'}, {
    get: {method: 'GET', params: {id: '@id'}}
  });
}]);

services.factory('ExperienceGetGroupSmallGroup', ['api_server', '$resource', function (api_server, $resource) {
  //  At this point, user is logged in now, connect student logged in user to teacher
  var url = api_server + '/local_groups/:id/get/small';
  return $resource(url, {id: '@id', gid: '@gid'},
    {
      get: {
        method: 'GET',
        params: {
          id: '@id',
          gid: '@gid'
        }
      }
    });
}]);


services.factory('StudentFactory', ['api_server', '$resource', function (api_server, $resource) {
  // Get List of students
  var url = api_server + '/local_groups/:id/get/students';

  return $resource(url, {
    id: '@id',
    gid: '@gid'
  }, {
    put: {
      method: 'put', params: {
        id: '@id',
        gid: '@gid'
      }
    }
  });
}]);

services.factory('StartActivityFactory', ['api_server', '$resource', function (api_server, $resource) {
  var url = api_server + '/experiences/:id/in/:user_id';
  return $resource(url, {id: '@id', user_id: '@user_id'}, {
    get: {method: 'GET', params: {id: '@id', user_id: '@user_id'}}
  });
}]);

services.factory('ActivityStateFactory', ['TimestampService', 'api_server', '$resource',
  function (TimestampService, api_server, $resource) {
    // Get List of students
    var url = api_server + '/experiences/:id/state/:user_id';
    return $resource(url, {id: '@id', user_id: '@user_id'}, {
      get: {method: 'GET', params: {id: '@id', user_id: '@user_id'}},
      post: {
        method: 'POST',
        url: api_server + '/experiences/:id/state',
        params: {
          id: '@id',
          user_id: '@user_id',
          current_scene_id: '@current_scene_id',
          student_facing_feedback: '@student_facing_feedback',
          timestamp: TimestampService.formatTimestamp(new Date())
        }
      }
    });
  }]);

services.factory('ActivityStateListFactory', ['api_server', '$resource', function (api_server, $resource) {
  // Get List of students
  var url = api_server + '/experiences/:id/state';
  return $resource(url, {id: '@id'}, {
    get: {method: 'GET', isArray: true, params: {id: '@id'}}
  });
}]);

services.factory('ExperienceState', ['$log', 'ActivityStateFactory', function ($log, ActivityStateFactory) {

  function setCurrentScene(experienceId, userId, sceneId) {
    return ActivityStateFactory.post({}, {'id': experienceId, 'user_id': userId, 'current_scene_id': sceneId})
      .$promise.then(function (result) {
        return result;
      })
      .catch(function (error) {
        $log.error("Set Current Scene error: " + error);
      });
  }

  function getCurrentScene(experienceId, userId) {
    return ActivityStateFactory.get({}, {'id': experienceId, 'user_id': userId})
      .$promise.then(function (response) {
        if (response && response.current_scene_id) {
          return response.current_scene_id;
        } else {
          return 1;
        }
      })
      .catch(function (error) {
        $log.error("Set Current Scene error: " + error);
      });
  }

  return {
    setCurrentScene: setCurrentScene,
    getCurrentScene: getCurrentScene
  };

}]);

services.factory('ExperienceStudentService', ['api_server', '$resource', function (api_server, $resource) {
  // manipulate student in an experience
  var url = api_server + '/experiences/:id/:operation';
  return $resource(url, {id: '@id'}, {
    Add: {method: 'PUT', params: {id: '@id', operation: 'add_students'}},
    Remove: {method: 'PUT', params: {id: '@id', operation: 'deinvite'}},
    Move: {method: 'PUT', params: {id: '@id', operation: 'move'}}
  });
}]);


//----------------------------------------------------------
//
// Save  the Experience
/*var parameters =
 {
 'teacher_user_id':  $scope.teacher_user_id,
 'catalog_item_id': $scope.catalog_item_id,
 'name': $scope.catalog_item_id,
 'section_name': $scope.section_name,
 'starts_at': $scope.section_name,
 'ends_at': $scope.profile.date_of_birth,
 'description' : $scope.description,
 'notification': $scope.notification,
 'students': $scope.students;
 };
 */
// ----------------------------------------------------------
services.factory('ExperienceSaveFactory', ['api_server', '$resource', function (api_server, $resource) {
  // works
  var url = api_server + '/experiences';
  return $resource(url, {}, {
    save: {method: 'POST'},
    saveMultiClass: {url: url + '/multiclass', method: 'POST', isArray: true}
  });
}]);
//
//server.post("/experiences/:id/invite", validate_session, controllers.experiences.invite_students, handle_error);
//
services.factory('ExperienceInviteStudentsFactory', ['api_server', '$resource', function (api_server, $resource) {
  // works
  var url = api_server + '/experiences/:id/invite';
  return $resource(url, {id: '@id'}, {
    post: {method: 'POST', params: {id: '@id'}}
  });
}]);

//server.put("/experiences/:id", validate_session, controllers.experiences.update, handle_error);

services.factory('ExperienceUpdateFactory', ['api_server', '$log', '$resource', function (api_server, $log, $resource) {
  var url = api_server + '/experiences/:id';

  return $resource(url,
    {
      id: '@id',
      name: '@name',
      section_name: '@section_name',
      starts_at: '@starts_at',
      ends_at: '@ends_at',
      description: '@description',
      notification: '@notification',
      students: '@students',
      small_groups: '@small_groups',
      is_guided: '@is_guided',
      preview: '@preview',
      return_url: '@return_url',
      project_id: '@project_id',
      class_id: '@class_id'
    },
    {
      update: {
        method: 'PUT',
        params: {
          id: '@id',
          name: '@name',
          section_name: '@section_name',
          starts_at: '@starts_at',
          ends_at: '@ends_at',
          description: '@description',
          notification: '@notification',
          students: '@students',
          small_groups: '@small_groups',
          is_guided: '@is_guided',
          preview: '@preview',
          return_url: '@return_url',
          class_id: '@class_id'
        }
      }
    });
}]);

services.factory('ExperienceStatusFactory', ['api_server', '$resource', function (api_server, $resource) {
  var url = api_server + `/experiences/:id/:action`;
  return $resource(url, {id: '@id'}, {
    end: {method: 'PUT', params: {id: '@id', action: 'end'}},
    reactivate: {method: 'PUT', params: {id: '@id', action: 'reactivate'}}
  });
}]);

// server.put("/local_groups/:id/create", validate_session, controllers.local_groups.create_group, handle_error);
// create a group out of list of students
// creates a NEW group
services.factory('StudentGroupNameFactory', ['api_server', '$resource', function (api_server, $resource) {
  var url = api_server + '/local_groups/:id/create';
  return $resource(url, {id: '@id', group_name: '@group_name', students: '@students', cid: '@cid'}, {
    update: {
      method: 'PUT',
      params: {
        id: '@id',
        group_name: '@group_name',
        students: '@students',
        cid: '@cid'
      }
    }
  });
}]);

// ====================================================
// Experience : Save (draft) and Invite(active)
// ====================================================
services.factory('ExperienceSaveAndInvite', ['$q', 'ExperienceSaveFactory', 'ExperienceInviteStudentsFactory', 'ExperienceUpdateFactory', '$log',
  function ($q, ExperienceSaveFactory, ExperienceInviteStudentsFactory, ExperienceUpdateFactory, $log) {
    // Flight API (each returns a promise)
    return {
      // Expose this function for controller
      publishExperience: function (params) {
        var dfd = $q.defer();

        // Mock departure information for the user's flight
        ExperienceSaveFactory.save({
          'parents': params.parents,
          'teacher_user_id': params.teacher_user_id,
          'catalog_item_id': params.catalog_item_id,
          'template_id': params.catalog_item_id,
          'name': params.name,
          'section_name': params.section_name,
          'starts_at': params.starts_at,
          'ends_at': params.ends_at,
          'description': params.description,
          'notification': params.notification,
          'small_groups': params.small_groups,
          'small_group_count': params.small_group_count,
          'small_group_id': params.small_group_id,
          'is_guided': params.is_guided,
          'preview': params.preview,
          'review': params.review,
          'return_url': params.return_url,
          'project_id': params.project_id,
          'class_id': params.class_id,
          'students': params.students,
          'reading_group_id': params.reading_group_id,
          'student_facing_feedback': params.student_facing_feedback || params.selfPaced,
          'open_all_gates_on_activation': params.open_all_gates_on_activation,
          'entire_class': params.entire_class
        }).$promise.then(function (oExperience)          // Request #1
        {
          // Response Handler #1
          dfd.resolve({
            dataResult: oExperience
          });
          return oExperience.id;
        });
        return dfd.promise;
      },
      publishMCExperience: function (experience) {
        return ExperienceSaveFactory.saveMultiClass(experience);
      },
      doUpdateExperience: function (params) {
        var dfd = $q.defer();

        // User is updating the experience
        ExperienceUpdateFactory.update({
          'parents': params.parents,
          'id': params.experience_id,
          'name': params.name,
          'section_name': params.section_name,
          'starts_at': params.starts_at,
          'ends_at': params.ends_at,
          'description': params.description,
          'notification': params.notification,
          'small_groups': params.small_groups,
          'is_guided': params.is_guided,
          'preview': params.preview,
          'return_url': params.return_url,
          'project_id': params.project_id,
          'class_id': params.class_id,
          'students': params.students,
          'reading_group_id': params.reading_group_id,
          'student_facing_feedback': params.student_facing_feedback
        }).$promise.then(function (oExperience) // Request #1
        {
          // Response Handler #1
          dfd.resolve({
            dataResult: oExperience
          });
          return oExperience;
        });
        return dfd.promise;
      },
      // Expose this function for controller
      doInviteStudents: function (experienceId) {
        var deferred = $q.defer();
        return ExperienceInviteStudentsFactory.post({id: experienceId}).$promise.then(function (oInviteResult) {
          // Response Handler #2
          return deferred.resolve({
            dataResult: oInviteResult

          });
        });
      } // End of function list
    }; // End of return
  }]);


// factory for adding all realtime events we expect to have in the system
// there is no need to remove events since we destroy the socket on disconnect
services.factory('RealtimeEvents', [
  'UserCourses', 'ClassMode', 'SegmentFactory',
  function (UserCourses, ClassMode, SegmentFactory) {
    var EVENTS = {
      Analytics: {
        XPAnalyticsTrackEvent: 'analytics/track'
      },
      Course: {
        XPNewCourseNotification: 'course_added',
        XPUpdateCourseNotification: 'course_updated',
        XPDeleteCourseNotification: 'course_deleted',
        XPArchiveCourseNotification: 'course_archived'
      },
      Students: {
        XPNewStudentdNotification: 'course_new_student'
      }
    };

    function addEvents(socket) {
      // Event listener for /analytics/track event received via Websocket
      socket.on(EVENTS.Analytics.XPAnalyticsTrackEvent, SegmentFactory.onTrack);

      socket.on(EVENTS.Course.XPNewCourseNotification, UserCourses.updateCachedCourses);
      socket.on(EVENTS.Course.XPUpdateCourseNotification, UserCourses.updateCachedCourses);
      socket.on(EVENTS.Course.XPDeleteCourseNotification, UserCourses.updateCachedCourses);
      socket.on(EVENTS.Course.XPArchiveCourseNotification, UserCourses.updateCachedCourses);
      socket.on(EVENTS.Course.XPNewCourseNotification, ClassMode.newCourseNotificationHandler);
      socket.on(EVENTS.Course.XPDeleteCourseNotification, ClassMode.deleteCourseNotificationHandler);
    }

    return {
      addEvents: addEvents,
      EVENTS: EVENTS,
      on: function (socket, type, fn) {
        socket.on(type, fn);
      },
      removeListener: function (socket, type, listener) {
        socket.removeListener(type, listener);
      }
    };
  }
]);


services.factory('WebSocket', ['$log', '$location', '$sessionStorage', 'User', 'UserInfoDefaultFactory',
  'RealtimeEvents',
  'ModalService', '$http', 'logoutService', 'InvalidateSessionFactory',
  '$rootScope', '$timeout', '$window', '$localStorage', 'token_cookie_name',
  function ($log, $location, $sessionStorage, User, UserInfoDefaultFactory,
            RealtimeEvents,
            ModalService, $http, logoutService, InvalidateSessionFactory,
            $rootScope, $timeout, $window, $localStorage, token_cookie_name) {
    const Realtime = require('./realtime');

    var socket = null;
    var connectionId = null;
    var alreadyShowingReloadPopUp = false;

    function disconnect(reason) {
      $log.info('Disconnect reqltime connection: ', reason);
      Realtime.turnOffRealtime(reason);
      socket = null;
    }

    function defineWebSocket(token) {
      $log.debug('Initializing websocket service.');
      socket = Realtime.initRealtime(token);

      if (!socket) {
        $log.info('Failed creating realtime connection with token: ', token);
        forceReloadPage("Failed to establish realtime connection");
        return;
      }

      socket.on('error', function (error) {
        $log.error('Websocket received error: ', error);
        var detail = error && error.detail ? error.detail : null;
        var innerError = detail && detail.error ? detail.error : null;
        if (innerError && innerError.type === 'error') {
          $log.warn('Realtime connection encountered a transient error; waiting for automatic retry.');
          return;
        }
        forceReloadPage(error, true);
      });

      socket.on('logout', function (e) {
        const reason = e.detail.reason;
        $log.warn("logout event: ", reason);
        forceReloadPage(reason);
      });

      socket.on('connected', function (e) {
        $log.debug('Websocket connected');
        if (token !== e.detail.token) {
          $log.debug('Token mismatch. Ignoring the connection.');
          return;
        }
        if (!connectionId) {
          $log.debug('Connection ID received: ', e.detail.connectionId);
          connectionId = e.detail.connectionId;
        }
      });

      socket.on('kickOut', function (e) {
        const reason = e.detail.reason;
        const tokenToKeep = e.detail.tokenToKeep;
        const connectionToKeep = e.detail.connectionToKeep;

        $log.warn("kickOut event: ", reason, {tokenToKeep, token, connectionToKeep, connectionId});

        if (tokenToKeep !== token) {
          forceReloadPage(reason, true);
          return;
        }

        if (connectionToKeep !== connectionId) {
          forceReloadPage(reason, true);
          return;
        }
      });

      RealtimeEvents.addEvents(socket);
    }

    function forceReloadPage(reason, keepLoggedIn = false) {
      // Invalidation must close realtime even when the duplicate-modal guard returns.
      if (reason === Realtime.CLOSE_REASONS.NEW_CLIENT || reason === Realtime.CLOSE_REASONS.LOGOUT) {
        disconnect(reason);
      }

      if (alreadyShowingReloadPopUp) {
        return;
      }

      alreadyShowingReloadPopUp = true;
      const token = User.getSessionToken();
      const recoverySocket = socket;
      function isCurrentRecovery() {
        const savedToken = $localStorage[token_cookie_name];
        return User.getSessionToken() === token && socket === recoverySocket &&
          (!savedToken || savedToken === token);
      }

      var msg = 'The connection to Exploros has been interrupted. Please click the Refresh button to reconnect.';
      var button = 'Refresh';

      // if this was caused by the same user connecting from another device then set a specific message
      if (reason && reason === Realtime.CLOSE_REASONS.NEW_CLIENT) {
        msg = 'Your log in is being used in another browser or device. Please click the Log in button to log in again.';
        button = 'Log in';
      }

      // It is possible that we already have a modal open when we received this error.
      // We want to therefore close all existing modals before we show this one.
      ModalService.hideAll();

      logoutService.stopMetering();

      ModalService.show({
        message: msg,
        backdrop: 'static',
        buttons: [
          {
            title: button,
            click: 'refreshPage(); $hide();'
          }
        ],
        refreshPage: function () {
          $log.debug("Refresh button pressed");

          $timeout(function () {
            alreadyShowingReloadPopUp = false;
            // Metering checks whether a user is still logged in.
            logoutService.continueMetering();
            if (!isCurrentRecovery()) {
              return;
            }
            // duplicate logic form loginService, but do not inject it because of circular dependencies

            if (!keepLoggedIn && token) {
              InvalidateSessionFactory.invalidate({token}).$promise.catch(function (error) {
                $log.warn('Failed to invalidate session before refresh.', error && error.status);
              }).then(function () {
                if (!isCurrentRecovery()) {
                  return;
                }
                User.logout();
                disconnect(reason);

                // redirect to login page
                $location.path('/login');
              });
            } else {
              $log.debug("Kick the connection, no logout message sent", reason);
              disconnect(reason);
              $location.path('/login');
            }
          });
        }
      });
    }

    function addListener(type, listener) {
      if (socket) {
        $log.debug("Websocket Added listener to " + type);
        socket.on(type, listener);
      } else {
        $log.debug("Added listener to " + type + " to rootScope");
        $rootScope.$on(type, listener);
      }
    }

    function removeListener(event, cb) {
      if (socket) {
        socket.off(event, cb);
      }
    }

    return {
      CLOSE_REASONS: Realtime.CLOSE_REASONS,
      on: addListener,

      defineWebSocket: defineWebSocket,
      disconnect: disconnect,

      send: function (subject, message) {
        if (socket) {
          $log.debug("Websocket Sending message: " + subject);
          socket.send({subject, message});
        }
      },
      forward: function (subject, message) {
        $log.debug("Websocket forward message: " + subject);
        $rootScope.$broadcast(subject, message);
      },
      removeListener: removeListener
    };
  }]);

services.factory('ElementRealtimeService', ['$log', 'WebSocket', function ($log, WebSocket) {
  $log.debug('Initializing ElementRealtimeService.');

  var EVENTS = Object.freeze(
    {
      XPElementStateChangedNotification: 'element_state',
      XPExperienceUpdatedNotification: 'experience_updated',
      XPActivityStateChangedNotification: 'activity_state',
      XPQuizStatusUpdate: 'quiz_update',
      XPSkipElementChangeNotification: 'skip_element'
    });

  return {
    EVENTS: EVENTS,
    on: function (type, fn) {
      WebSocket.on(type, fn);
    },
    removeListener: function (type, listener) {
      WebSocket.removeListener(type, listener);
    }
  };
}]);

services.factory('ExperienceRealtimeService', ['$log', 'WebSocket', function ($log, WebSocket) {
  $log.debug('Initializing ExperienceRealtimeService.');

  return {
    EVENTS: Object.freeze({
      XPNewExperienceNotification: 'new_experience',
      XPUpdateExperienceNotification: 'experience_updated',
      XPExperienceStudentRemovedNotification: 'experience_student_removed',
      XPStudentCanRaiseHandNotification: 'allowRaiseHand',
      XPStudentRaisedHandNotification: 'putHandUp',
      XPTeacherEnabledStudentAudioNotification: 'letStudentTalk',
      XPStudentAudioResponseNotification: 'studentParticipation',
      XPMediaStartedNotification: 'media_started',
      XPStreamingStatusNotification: 'streamingStatus'
    }),
    on: function (type, fn) {
      WebSocket.on(type, fn);
    },
    removeListener: function (type, listener) {
      WebSocket.removeListener(type, listener);
    }
  };
}]);

services.factory('UserLastActive', ['$log', 'User', '$localStorage', function ($log, User, $localStorage) {
  $localStorage.user_last_active = $localStorage.user_last_active || {};
  return {
    set: function setUserLastActive() {
      var now = Date.now();
      var userId = User.getId() || 'anonymous';
      var key = 'UserLastActive_' + userId;
      $localStorage.user_last_active[key] = now;
      return now;
    },
    get: function getUserLastActive() {
      var userId = User.getId() || 'anonymous';
      var key = 'UserLastActive_' + userId;
      var last = $localStorage.user_last_active[key] || Date.now();
      return last;
    }
  };
}]);

services.factory('PresenceService', ['$log', 'WebSocket', 'UserLastActive', function ($log, WebSocket, UserLastActive) {
  $log.debug('Initializing PresenceService.');

  return {
    EVENTS: Object.freeze({XPPresenceReceivedNotification: 'presence'}),
    on: function (type, fn) {
      WebSocket.on(type, function () {
        UserLastActive.set();
        fn.apply(this, arguments);
      });
    },
    removeListener: function (type, listener) {
      WebSocket.removeListener(type, listener);
    }
  };
}]);

services.factory('TeacherControlledEvent', ['api_server', '$resource', function (api_server, $resource) {
  var url = api_server + '/experiences/:id/control/:type';

  return $resource(url, {
      id: '@id',
      scene: '@sceneId',
      quiz_cluser_id: '@quiz_cluser_id'
    },
    {
      post: {
        method: 'POST', params: {
          id: '@id',
          type: 'guided_navigation',
          scene: '@sceneId',
          event: '@event'
        }
      },
      quiz: {
        method: 'POST', params: {
          id: '@id',
          type: 'quiz',
          quiz_cluser_id: '@quiz_cluser_id',
          event: '@event'
        }
      }
    });
}]);

services.factory('TeacherControlledRealtimeService', ['$log', 'WebSocket', function ($log, WebSocket) {
  $log.debug('Initializing TeacherControlledRealtimeService.');

  return {
    EVENTS: Object.freeze({TeacherControlledEvent: 'teacher_control'}),
    on: function (type, fn) {
      WebSocket.on(type, fn);
    },

    removeListener: function (type, listener) {
      WebSocket.removeListener(type, listener);
    }
  };
}]);

services.factory('WhiteboardRealtimeService', ['$log', 'WebSocket', function ($log, WebSocket) {
  $log.debug('Initializing WhiteboardRealtimeService.');

  return {
    EVENTS: Object.freeze({WhiteboardEvent: 'whiteboard'}),
    on: function (type, fn) {
      WebSocket.on(type, fn);
    },

    removeListener: function (type, listener) {
      WebSocket.removeListener(type, listener);
    }
  };
}]);

services.factory('SchoolsFactory',
  ['$resource', 'api_server', function ($resource, api_server) {
    var url = api_server + '/schools';
    return $resource(url, {}, {
      get: {
        url: url + '/:id',
        method: 'GET',
        params: {id: '@id'}
      },
      list: {
        method: 'GET',
        params: {zipcode: '@zipcode'}
      }
    });
  }]);


services.factory('CourseFactory', ['$rootScope', '$q', 'CourseAPI', 'PageService', '$sce',
  'User', 'userClassPermissions', 'xpAlert', '$log', 'ModalNavigation', 'ModalService',
  function ($rootScope, $q, CourseAPI, PageService, $sce, User, userClassPermissions, xpAlert, $log, ModalNavigation, ModalService) {
    var currentCourse = {};
    var courseList = [];
    var successMsgPre = 'You successfully created a class! You can <a href=\"/class/';
    var successMsgPost = '/roster\">add students now</a> or later.';

    function broadcast(current) {
      var curr = (current || currentCourse);
      curr.path = curr.cid ? '/class/' + curr.cid + (PageService.getNavView() === 'reports' ? '/reports' : '') : 'experience';

      $rootScope.$broadcast('current_course_updated', {
        current: curr
      });
    }

    return {
      get: function (id) {
        var d = $q.defer();

        // if the current course is already set then just return it
        if ((currentCourse && id && id == currentCourse.cid) || (!id && currentCourse && Object.keys(currentCourse).length > 0)) {
          d.resolve(currentCourse);
          return d.promise;
        }

        CourseAPI.get({cid: id}).$promise
          .then(function (course) {
            d.resolve(course);
          });

        return d.promise;
      },
      list: function (params) {
        var d = $q.defer();

        if (params && params.cache) {
          d.resolve(courseList);
          return d.promise;
        }

        CourseAPI.list(params).$promise
          .then(function (courses) {
            courseList = courses;
            d.resolve(courses);
          });

        return d.promise;
      },
      add: function (params) {
        var d = $q.defer();

        CourseAPI.add(params).$promise
          .then(function (course) {
            if (course.error) {
              ModalService.show({
                message: course.error.description,
                backdrop: 'static',
                buttons: [
                  {
                    title: 'Ok',
                    click: '$hide();'
                  }
                ]
              });
              return;
            }
            var remove = $rootScope.$on('$routeChangeSuccess', function (event, current, prev) {
              if (current &&
                current.$$route &&
                current.$$route.originalPath == '/class/:classId' &&
                current.pathParams &&
                current.pathParams.classId == course.cid) {
                remove();
                var successMsg = successMsgPre + course.cid + successMsgPost;
                var close = xpAlert.success(successMsg, true);

                remove = $rootScope.$on('$routeChangeSuccess', function (event, current, prev) {
                  ModalNavigation.setBackDestination('/class/' + course.cid);
                  remove();
                  close();
                });
              }
            });

            broadcast(course);

            d.resolve(course);
          }, function (error) {
            d.reject(error);
          });

        return d.promise;
      },
      update: function (params) {
        return CourseAPI.get({cid: params.cid}).$promise
          .then(function (oldCourse) {
            return CourseAPI.update(params).$promise
              .then(function (course) {
                if (course && course.licenses && course.licenses.length && oldCourse.licenses.length === 0) {
                  var msg = "You successfully licensed a class with " + course.totalStudents + " students!";
                  if (!course.sufficientSeats) {
                    msg = msg + " However, you exceeded your seat license limit. <a href=\"http://help.exploros.com/en/articles/4912771-seat-licenses-for-teachers\" target=blank> Learn more.</a>";
                  }
                  var close = xpAlert.success(msg, true);

                  var remove = $rootScope.$on('$routeChangeSuccess', function (event, current, prev) {
                    remove();
                    close();
                  });
                }
                currentCourse = course;
                broadcast(course);
                return course;
              });
          });
      },
      remove: function (id) {
        var d = $q.defer();

        CourseAPI.remove({cid: id}).$promise
          .then(function (response) {
            currentCourse = {};
            broadcast(currentCourse); // Broadcast currentCourse as empty object so we don't get any JS errors
            d.resolve(response);
          });

        return d.promise;
      },
      archive: function (id, remove_students) {
        return CourseAPI.archive({cid: id, remove_students: remove_students}).$promise
          .then(function (response) {
            currentCourse = {};
            broadcast(currentCourse); // Broadcast currentCourse as empty object so we don't get any JS errors
            return response;
          });
      },
      maxStudents: function () {
        return CourseAPI.maxStudents().$promise;
      },
      maxStudentsMsg: function () {
        return this.maxStudents().then(function (results) {
          var exceededMaxStudentsMsg = "Class sizes are limited to " + results.maxStudents + " students " +
            "<a href='http://help.exploros.com/en/articles/4142954-class-size-limit' target='_blank'>" +
            "(see why).</a> You cannot add additional students to this class.";
          return exceededMaxStudentsMsg;
        });
      },
      getStudents: function (id) {
        return CourseAPI.getStudents({cid: id}).$promise
          .then(function (course) {
            return course;
          });
      },
      getStudentsAndTeachers: function (id) {
        return CourseAPI.getStudentsAndTeachers({cid: id}).$promise
          .then(function (course) {
            return course;
          });
      },
      getCampusStudents: function (id) {
        return CourseAPI.getCampusStudents({cid: id}).$promise
          .then(function (students) {
            return students;
          });
      },
      addStudents: function (params) {
        return CourseAPI.addStudents(params).$promise
          .then(function (course) {
            return course;
          });
      },
      addTeachers: function (params) {
        return CourseAPI.addTeachers(params).$promise
          .then(function (course) {
            return course;
          });
      },
      removeStudentsFromTeacher: function (params) {
        var d = $q.defer();

        CourseAPI.removeStudentsFromTeacher(params).$promise
          .then(function (course) {
            d.resolve(course);
          });

        return d.promise;
      },
      removeStudents: function (params) {
        return CourseAPI.removeStudents(params).$promise
          .then(function (course) {
            return course;
          });
      },
      removeTeachers: function (params) {
        return CourseAPI.removeTeachers(params).$promise
          .then(function (course) {
            return course;
          });
      },
      getCurrentCourse: function () {
        var d = $q.defer();

        if (!currentCourse || Object.keys(currentCourse).length === 0) {
          d.reject(currentCourse);
          return d.promise;
        }

        d.resolve(currentCourse);

        return d.promise;
      },
      setCurrentCourse: function (id) {
        if (!id) {
          currentCourse = {};
          userClassPermissions.clearPermissions();
          broadcast(currentCourse);
          return $q.resolve(currentCourse);
        }

        userClassPermissions.setUserClassPermissions(User.getId(), id);

        return CourseAPI.get({cid: id}).$promise
          .then(function (course) {
            currentCourse = course;
            broadcast(currentCourse);
            return currentCourse;
          })
          .catch(function (error) {
            $log.error("error in get course factory:", error);
            return $q.reject(error);
          });
      },
      createAndAddToClass: function (cid, auth) {
        return CourseAPI.createAndAddToClass(cid, auth).$promise
          .then(function (course) {
            return course;
          });
      },
      initializeSyncSettings: function (courseIn, config, course) {
        // Initialize syncOnLogin from backend unified endpoint (ClassLink, Clever, and Schoology)
        const imsId = Number(courseIn && courseIn.ims_id);
        const isClassLink = courseIn && courseIn.cid && imsId === -8;
        const isClever = courseIn && courseIn.cid && imsId === -7;
        const isSchoology = courseIn && courseIn.cid && imsId === -4;
        
        if (isClassLink || isClever || isSchoology) {
          try {
            return CourseAPI.getSyncSettings({cid: courseIn.cid}).$promise.then(function (resp) {
              if (resp && typeof resp.syncOnLogin !== 'undefined') {
                const val = !!resp.syncOnLogin;
                course.syncOnLogin = val;
                
                if (isClassLink) {
                  config.classLink = config.classLink || {};
                  config.classLink.syncOnLogin = val;
                }
                if (isClever) {
                  config.clever = config.clever || {};
                  config.clever.syncOnLogin = val;
                }
                if (isSchoology) {
                  config.schoology = config.schoology || {};
                  config.schoology.syncOnLogin = val;
                }
              }
              // Handle integration status for UI control (ClassLink)
              if (isClassLink && resp && resp.integration) {
                config.integrationStatus = resp.integration;
                // Set flags for conditional rendering
                config.classLinkTabVisible = resp.integration.status === 'active';
                config.isClassLinkSyncDisabled = resp.integration.status === 'active' && 
                                                 !resp.integration.allowLoginSync;
              } else if (isClassLink) {
                // Default: hide tab if no integration status (integration not found or not ClassLink)
                config.classLinkTabVisible = false;
                config.isClassLinkSyncDisabled = false;
              }

              if (isClever && resp && resp.integration) {
                config.cleverIntegrationStatus = resp.integration;
                config.cleverTabVisible = true;
                config.isCleverSyncDisabled = resp.integration.allowLoginSync === false ||
                                              resp.integration.allowLoginSync === 0;
              } else if (isClever) {
                config.cleverTabVisible = true;
                config.isCleverSyncDisabled = false;
              }
              
              // Handle integration status for UI control (Schoology)
              if (isSchoology && resp && resp.integration) {
                config.schoologyIntegrationStatus = resp.integration;
                // Set flags for conditional rendering
                config.schoologyTabVisible = true; // Always show tab for Schoology classes
                config.isSchoologySyncDisabled = resp.integration.status === 'active' && 
                                                 !resp.integration.allowLoginSync;
              } else if (isSchoology) {
                // Default: allow sync if no integration record (backward compatible)
                config.schoologyTabVisible = true;
                config.isSchoologySyncDisabled = false;
              }

            });
          } catch (e) {
            return $q.resolve(); // ignore init errors
          }
        }
        return $q.resolve();
      }
    };
  }]);

services.factory('ElementsRestService', ['$resource', '$upload', 'TimestampService', '$log', '$timeout', 'api_server',
  function ($resource, $upload, TimestampService, $log, $timeout, api_server) {
    var stateCache = {};

    function enableExperienceCache(experienceId) {
      stateCache[experienceId] = stateCache[experienceId] || {};
    }

    function disableExperienceCache(experienceId) {
      if (stateCache[experienceId]) {
        delete stateCache[experienceId];
      }
    }

    return {
      saveUserState: function (experienceId, elementId, userId, small_gid, userData, success, error, uploads, timestamp) {
        var params =
          {
            url: api_server + '/elements/' + elementId + '/experience/' + experienceId + '/state',
            data: {
              element_id: elementId,
              experience_id: experienceId,
              user_id: userId,
              small_gid: small_gid,
              timestamp: TimestampService.formatTimestamp(timestamp),
              user_data: userData
            }
          };

        if (uploads) {
          var keys = Object.keys(uploads);

          if (keys.length == 1) {
            var key = keys[0];
            params.file = uploads[key];
            params.fileName = key;
            params.fileFormDataName = key;
          } else if (keys.length > 1) {
            params.file = [];
            params.fileName = [];
            params.fileFormDataName = [];
            keys.forEach(function (key) {
              params.file.push(uploads[key]);
              params.fileName.push(key);
              params.fileFormDataName.push(key);

            });
          }
        }

        $upload.upload(params).then(function (response) {
            var ret = response.data;
            if (!ret.experience_id) {
              ret.experience_id = experienceId;
            }

            success(response.data);
          },
          error, function (evt) {
            $log.debug('percent: ' + parseInt(100.0 * evt.loaded / evt.total, 10));
          });
      },
      saveAnalyticsUserState: function (experienceId, elementId, userId, small_gid, oldUserData, userData, success, error, uploads, timestamp) {
        var params =
          {
            url: api_server + '/elements/' + elementId + '/experience/' + experienceId + '/analytics_state',
            data: {
              element_id: elementId,
              experience_id: experienceId,
              user_id: userId,
              small_gid: small_gid,
              timestamp: TimestampService.formatTimestamp(timestamp),
              old_user_data: oldUserData,
              user_data: userData
            }
          };

        if (uploads) {
          var keys = Object.keys(uploads);

          if (keys.length == 1) {
            var key = keys[0];
            params.file = uploads[key];
            params.fileName = key;
            params.fileFormDataName = key;
          } else if (keys.length > 1) {
            params.file = [];
            params.fileName = [];
            params.fileFormDataName = [];
            keys.forEach(function (key) {
              params.file.push(uploads[key]);
              params.fileName.push(key);
              params.fileFormDataName.push(key);

            });
          }
        }

        $upload.upload(params).then(function (response) {
            var ret = response.data;
            if (!ret.experience_id) {
              ret.experience_id = experienceId;
            }

            success(response.data);
          },
          error, function (evt) {
            $log.debug('percent: ' + parseInt(100.0 * evt.loaded / evt.total, 10));
          });
      },
      enableExperienceCache: enableExperienceCache,
      disableExperienceCache: disableExperienceCache,
      getSharedState: function (experienceId, elementId, groupName, isInactive, success, error) {

        if (isInactive) {
          $log.debug("Use historical data for element " + elementId);

          if (stateCache[experienceId]) {
            if (stateCache[experienceId][elementId]) {
              $timeout(success, 0, true, stateCache[experienceId][elementId]);
              return;
            }

            var oldSuccess = success;
            success = function (result) {
              stateCache[experienceId][elementId] = result;
              $timeout(oldSuccess, 0, true, result);
            };
          }

          $resource(api_server + '/experiences/:experience_id/elements/:element_id/state/shared').query(
            {
              experience_id: experienceId,
              element_id: elementId,
              group: groupName
            }, success, error);
        } else {
          $log.debug("Use realtime data for element " + elementId);

          $resource(api_server + '/elements/:element_id/experience/:eid/state/shared').query(
            {
              element_id: elementId,
              eid: experienceId,
              group: groupName
            }, success, error);
        }
      },
      getLastValidSharedQuizState: function (experienceId, elementId, groupName, isInactive, success, error) {
        $resource(api_server + '/experiences/:experience_id/elements/:element_id/quiz/state/shared').query(
          {
            experience_id: experienceId,
            element_id: elementId,
            group: groupName
          }, success, error);
      },
      getSharedStatePromise: function (experienceId, elementId, groupName, isInactive, success, error) {
        if (isInactive) {
          return $resource(api_server + '/experiences/:experience_id/elements/:element_id/state/shared')
            .query({
              experience_id: experienceId,
              element_id: elementId,
              group: groupName
            }).$promise;
        } else {
          return $resource(api_server + '/elements/:element_id/experience/:eid/state/shared')
            .query({
              element_id: elementId,
              eid: experienceId,
              group: groupName
            }).$promise;
        }
      },
      getExperienceStudentsNumber: function (experienceId, success, error) {
        $resource(api_server + '/experiences/:experience_id/class').get(
          {
            experience_id: experienceId
          },
          function (expClass) {
            var numberOfStudents = expClass.students ? expClass.students.length : 0;
            success(numberOfStudents);
          });
      },
      getUserState: function (experienceId, elementId, userId, callback) {
        $resource(api_server + '/elements/:element_id/experience/:eid/state/user?user_id=:user_id').get({
            element_id: elementId,
            eid: experienceId,
            user_id: userId
          },
          function (data) {
            callback(data);
          }, function (error) {
            callback(null, error);
          });
      },
      approveAnalyticsUserState: function (experienceId, elementId) {
        return $resource(api_server + '/elements/:element_id/experience/:eid/analytics_approve').get(
          {
            element_id: elementId,
            eid: experienceId
          }).$promise;
      }
    };
  }]);

services.factory('ElementsErrorService', ['$log', 'ModalService', function ($log, ModalService) {
  return {
    error: function (error) {
      $log.error(error);
      ModalService.show({
        message: "There was a problem sending your response to the Exploros server. Please check your internet connection then click Ok and try again.",
        backdrop: 'static',
        buttons: [
          {
            title: 'Ok',
            click: '$hide();'
          }
        ]
      });
    }
  };
}]);

services.factory('JSONStringUtility', ['$log', function ($log) {
  return {
    parse: function (value) {
      if (typeof value !== 'string') {
        return value;
      }
      try {
        return JSON.parse(value);
      }
      catch (e) {
        $log.error("Failed to parse JSON string:", value);
        return {};
      }
    },
    stringify: function (value) {
      return JSON.stringify(value);
    }
  };
}]);

services.factory('ElementUtilities', function () {
  return {
    getElementURL: function (element, experience_id, url) {
      if (url.indexOf('asset://') === 0) {
        var xid = url.substring(8);
        if (element.assets) {
          element.assets.forEach(function (asset) {
            if (asset.xid === xid) {
              url = asset.url;
            }
          });
        }
      }
      return url;
    }
  };
});


services.factory('CameraService', function ($window) {
  var hasUserMedia = function () {
    return !!getUserMedia();
  };

  var getUserMedia = function () {
    navigator.getUserMedia = ($window.navigator.getUserMedia ||
      $window.navigator.webkitGetUserMedia ||
      $window.navigator.mozGetUserMedia ||
      $window.navigator.msGetUserMedia);
    return navigator.getUserMedia;
  };
  return {
    hasUserMedia: hasUserMedia,
    getUserMedia: getUserMedia
  };
});

services.factory('UserIconService', [function () {
  var listeners = [];
  return {
    addCallback: function (fn) {
      listeners.push(fn);
    },
    removeCallbacks: function () {
      listeners = [];
    },
    profilePictureUpdated: function (userId) {
      listeners.forEach(function (fn) {
        fn(userId);
      });
    }
  };

}]);

services.factory('loadImageWithOrientation', ['$q', 'BlobUtilities', function ($q, BlobUtilities) {

  function loadImageWithOrientation(file, options) {
    /* global loadImage */
    var deferred = $q.defer();

    loadImage.parseMetaData(file, function (data) {
      if (angular.isUndefined(options) || options === null) {
        options = {};
      } else {
        options = angular.copy(options);
      }

      options.canvas = true;

      if (data.exif) {
        options.orientation = data.exif.get('Orientation');
        loadImage(file, function (img) {
            if (img.type === 'error') {
              deferred.reject(img);
            } else {
              var imageURL = img.toDataURL("image/jpeg", 1.0);
              var blob = BlobUtilities.dataURLToBlob(imageURL, 'image/jpeg');
              deferred.resolve(blob);
            }
          },
          options
        );
      } else {
        deferred.resolve(file);
      }
    });

    return deferred.promise;
  }

  return loadImageWithOrientation;
}]);

services.factory('ImageFileModificationService', ['$q', function ($q) {

  function scaleImageToDataURL(image, width, height, scaleUp) {
    if (!scaleUp && image.width < width && image.height < height) {
      width = image.width;
      height = image.height;
    }

    var canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    canvas.getContext('2d').drawImage(image, 0, 0, width, height);
    return canvas.toDataURL("image/png");
  }

  function cropImageToDataURL(image, x, y, width, height) {
    var canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    canvas.getContext('2d').drawImage(image, -x, -y, image.width, image.height);
    return canvas.toDataURL("image/png");
  }

  function scaleAndCropImageToDataURL(image, scaleWidth, scaleHeight, x, y, width, height) {
    var canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    canvas.getContext('2d').drawImage(image, -x, -y, scaleWidth, scaleHeight);
    return canvas.toDataURL("image/png");
  }

  function getScaleImageFromSrcPromise(srcPromise, width, height, scaleUp) {
    var deferred = $q.defer();

    function onLoadImage() {
      // If the image is smaller than the target, don't scale it up
      if (!scaleUp && this.width < width && this.height < height) {
        width = this.width;
        height = this.height;
      }

      var dataURL = scaleImageToDataURL(this, width, height, scaleUp);

      deferred.resolve(dataURL);
    }

    srcPromise.then(function (src) {
      var img = new Image();
      img.onload = onLoadImage;
      img.src = src;
    });

    return deferred.promise;
  }

  function getScaleImageProportionallyFromSrcPromise(srcPromise, maxWidth, maxHeight) {
    var deferred = $q.defer();

    function onLoadImage() {
      var width = this.width;
      var height = this.height;

      // Calculate the direction that exceeds the max size by the most
      var widthDiff = this.width - maxWidth;
      var heightDiff = this.height - maxHeight;

      // Only scale if the image is bigger than the max size in either direction
      if (widthDiff > 0 || heightDiff > 0) {
        // if the difference in the width is larger then reduce to max width and scale the height proportionally
        if (widthDiff > heightDiff) {
          width = maxWidth;
          height = this.height * (maxWidth / this.width);
        } else {
          height = maxHeight;
          width = this.width * (maxHeight / this.height);
        }
      }

      var dataURL = scaleImageToDataURL(this, width, height, false);

      deferred.resolve(dataURL);
    }

    srcPromise.then(function (src) {
      var img = new Image();
      img.onload = onLoadImage;
      img.src = src;
    });

    return deferred.promise;
  }

  function getFileLoadAsDataURLPromise(file) {
    var deferred = $q.defer();

    function onLoadFile(event) {
      var fileDataURL = event.target.result;
      deferred.resolve(fileDataURL);
    }

    var reader = new FileReader();
    reader.onload = onLoadFile;
    reader.readAsDataURL(file);

    return deferred.promise;
  }

  return {
    scaleFile: function (file, width, height, scaleUp) {
      var fileLoadAsDataURLPromise = getFileLoadAsDataURLPromise(file);
      return getScaleImageFromSrcPromise(fileLoadAsDataURLPromise, width, height, scaleUp);
    },
    scaleFileDownProportionally: function (file, maxWidth, maxHeight) {
      var fileLoadAsDataURLPromise = getFileLoadAsDataURLPromise(file);
      return getScaleImageProportionallyFromSrcPromise(fileLoadAsDataURLPromise, maxWidth, maxHeight);
    },
    scaleImgFromURL: function (url, width, height, scaleUp) {
      var deferred = $q.defer();
      var promise = getScaleImageFromSrcPromise(deferred.promise, width, height, scaleUp);
      deferred.resolve(url);
      return promise;
    },
    scaleImageToDataURL: scaleImageToDataURL,
    cropImageToDataURL: cropImageToDataURL,
    scaleAndCropImageToDataURL: scaleAndCropImageToDataURL
  };
}]);


services.factory('UserIconUploadService', ['$upload', 'UserIconService', 'BlobUtilities', 'api_server',
  function ($upload, UserIconService, BlobUtilities, api_server) {
    function uploadIcon(userId, data) {
      var params =
        {
          url: api_server + '/users/' + userId + '/photo/upload',
          file: data,
          filename: 'snapshot',
          fileFormDataName: 'snapshot'
        };

      return $upload.upload(params).success(function () {
        UserIconService.profilePictureUpdated(userId);
      });
    }

    return {
      uploadIconFromDataURL: function (userId, dataURL) {
        var blob = BlobUtilities.dataURLToBlob(dataURL, 'image/png');
        return uploadIcon(userId, blob);
      }
    };
  }]);

services.factory('BlobUtilities', function () {

  function dataURLToBlob(dataURL, mimeType) {
    var data = dataURL.split(',')[1];
    var blob = stringToBlob(data, mimeType);
    return blob;
  }

  function stringToBlob(string, mimeType) {
    var binary = atob(string);
    var array = [];
    for (var i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }

    var blob = new Blob([new Uint8Array(array)], {type: mimeType});
    return blob;
  }

  return {
    dataURLToBlob: dataURLToBlob,
    stringToBlob: stringToBlob
  };
});

services.factory('FileReaderFactory', ["$q", "$log", function ($q, $log) {

  var onLoad = function (reader, deferred, scope) {
    return function () {
      scope.$apply(function () {
        deferred.resolve(reader.result);
      });
    };
  };

  var onError = function (reader, deferred, scope) {
    return function () {
      scope.$apply(function () {
        deferred.reject(reader.result);
      });
    };
  };

  var onProgress = function (reader, scope) {
    return function (event) {
      scope.$broadcast("XP_FILE_PROGRESS",
        {
          total: event.total,
          loaded: event.loaded
        });
    };
  };

  var getReader = function (deferred, scope) {
    var reader = new FileReader();
    reader.onload = onLoad(reader, deferred, scope);
    reader.onerror = onError(reader, deferred, scope);
    reader.onprogress = onProgress(reader, scope);
    return reader;
  };

  var readAsDataURL = function (file, scope) {
    var deferred = $q.defer();

    var reader = getReader(deferred, scope);
    reader.readAsDataURL(file);

    return deferred.promise;
  };

  return {
    readAsDataUrl: readAsDataURL
  };
}]);

services.factory('ModalService', ["$modal", "$rootScope", "$timeout", "$document", function ($modal, $rootScope, $timeout, $document) {
  var modals = [];
  var activeModal = {};

  var service = {
    show: function (options) {
      var alertScope = $rootScope.$new(true);
      for (var name in options) {
        if (options.hasOwnProperty(name)) {
          alertScope[name] = options[name];
        }
      }

      alertScope.scope = alertScope;

      if (options.showTextInput) {
        alertScope.autofocus = false;
        alertScope.$on('modal.show', function () {
          $timeout(function () {
            alertScope.autofocus = true;
          }, 1);
        });
      }

      var animation = options.hasOwnProperty('animation') ? options.animation : 'am-fade';
      var backdrop = options.hasOwnProperty('backdrop') ? options.backdrop : true;
      var backdropAnimation = options.hasOwnProperty('backdropAnimation') ? options.backdropAnimation : 'am-fade';
      var keyboard = options.hasOwnProperty('keyboard') ? options.keyboard : true;
      var container = options.hasOwnProperty('container') ? options.container : false;
      var placement = options.hasOwnProperty('placement') ? options.placement : 'top';
      var displayCloseButton = options.hasOwnProperty('displayCloseButton') ? options.displayCloseButton : true;

      alertScope.modal = $modal(
        {
          id: options.id,
          show: false,
          template: options.template || require('../../views/partials/modals/alertModal.jade'),
          scope: alertScope,
          animation: animation,
          backdrop: backdrop,
          backdropAnimation: backdropAnimation,
          container: container,
          placement: placement,
          keyboard: keyboard,
          displayCloseButton: displayCloseButton
        });

      if (options.hasOwnProperty('onHide')) {
        var clearListener;
        var internalOnHide = function () {
          clearListener();
          options.onHide();
        };

        clearListener = alertScope.$on('modal.hide', internalOnHide);
      }


      alertScope.modal.$promise.then(alertScope.modal.show);

      return alertScope.modal;
    },
    update: function (scope, options) {
      var alertScope = scope;
      for (var name in options) {
        if (options.hasOwnProperty(name)) {
          alertScope[name] = options[name];
        }
      }

      alertScope.scope = alertScope;
    },
    error: function (error) {
      activeModal.$scope.invalidValue = error;
    },
    list: function () {
      return modals;
    },
    active: function () {
      return activeModal || {};
    },
    hide: function (modal) {
      if (!modal) {
        return;
      }

      modal.$promise.then(function () {
        modal.hide();
        service.onHide(modal);
      });
    },
    hideAll: function () {
      if (modals.length) {
        angular.forEach(modals, function (modal) {
          service.hide(modal);
        });

        modals = [];
      }

      activeModal = {};

      $document.find('body').removeClass('modal-open');
    },
    onBeforeShow: function (modal) {
      activeModal = modal;
    },
    onShow: function (modal) {
      if (modals.indexOf(modal) === -1) {
        modals.push(modal);
      }

      $document.find('body').addClass('modal-open');
    },
    onHide: function (modal) {
      // For every dialog we create using the ModalService we create our own scope (see var alertScope = $rootScope.$new(true); above).
      // Per the angular documentation, if we create our own scope then we are responsible for deleting it.  So whenever a dialog is
      // destroyed (hidden) we need to destroy the scope we created for it.  Otherwise, it will leave the scope values in the digest loop
      // and they will continue to be evaluated long after the dialog is destroyed.
      modal.$scope.$destroy();


      // Remove modal reference on modal.hide
      modals.splice(modal.$id);
      if (modals.length === 0) {
        $document.find('body').removeClass('modal-open');
      }
    }
  };

  $rootScope.$on('modal.show.before', function (e, modal) {
    service.onBeforeShow(modal);
  });

  $rootScope.$on('modal.show', function (e, modal) {
    // Add modal reference on modal.show if it's is not already in list
    service.onShow(modal);
  });

  $rootScope.$on('modal.hide', function (e, modal) {
    service.onHide(modal);
  });

  return service;
}]);

services.factory('AlertService', ["$rootScope", "$alert", function ($rootScope, $alert) {
  return {
    show: function (options) {
      var alertScope = $rootScope.$new(true);
      for (var name in options) {
        if (options.hasOwnProperty(name)) {
          alertScope[name] = options[name];
        }
      }

      alertScope.scope = alertScope;

      alertScope.alert = $alert(
        {
          template: require('../../views/partials/alert.jade'),
          animation: 'am-fade',
          duration: options.duration || false,
          container: 'header.notification',
          type: options.type || 'info',
          scope: alertScope
        });
      alertScope.alert.$promise.then(alertScope.alert.show);
    }
  };
}]);

services.factory('PackDetails', ['$log', function ($log) {
  var experienceId;
  var title = '';
  var description = '';
  var url = '';
  var assetUrl = '';
  var mediaType = '';
  var radioModelPack = 0; // Either 300 or 400: Pack state [Student/Teacher]
  var packPageOrigin = false;
  var sourceURL = '';
  return {
    getExperienceId: function () {
      return experienceId;
    },
    setExperienceId: function (value) {
      experienceId = value;
    },
    getTitle: function () {
      return title;
    },
    setTitle: function (value) {
      title = value;
    },
    getDescription: function () {
      return description;
    },
    setDescription: function (value) {
      description = value;
    },
    getUrl: function () {
      return url;
    },
    setUrl: function (value) {
      url = value;
    },
    getAssetUrl: function () {
      return assetUrl;
    },
    setAssetUrl: function (value) {
      assetUrl = value;
    },
    getMediaType: function () {
      return mediaType;
    },
    setMediaType: function (value) {
      mediaType = value;
    },

    getRadioModelPack: function () {
      return radioModelPack;
    },
    setRadioModelPack: function (value) {
      radioModelPack = value;
    },
    getPackPageOrigin: function () {
      return packPageOrigin;
    },
    setPackPageOrigin: function (value) {
      packPageOrigin = value;
    },
    getSourceURL: function () {
      return sourceURL;
    },
    setSourceURL: function (value) {
      sourceURL = value;
    }
  };
}]);

services.factory('TimestampService', function () {
  return {
    formatTimestamp: function (timestamp) {
      if (timestamp === null || timestamp === undefined) {
        var newtimestamp = new Date();
        return newtimestamp.toISOString();
      }
      if (timestamp instanceof Date) {
        return timestamp.toISOString();
      }
      if (timestamp instanceof String) {
        return timestamp;
      }
    }
  };
});

services.factory('SHARE_MODE', function () {
  function isUsingSmallGroups(mode) {
    return mode == SHARE_MODE.SMALL_GROUP_TEACHER || mode == SHARE_MODE.SMALL_GROUP_GROUP || mode == SHARE_MODE.STUDENT_SMALL_GROUP;
  }

  function isShareToGroup(mode) {
    switch (mode) {
      case SHARE_MODE.TEACHER:
      case SHARE_MODE.SMALL_GROUP_TEACHER:
      case SHARE_MODE.GROUP_TEACHER:
        return false;
      case SHARE_MODE.GROUP:
      case SHARE_MODE.STUDENT_SMALL_GROUP:
      case SHARE_MODE.SMALL_GROUP_GROUP:
      case SHARE_MODE.GROUP_GROUP:
        return true;
    }

    return false;
  }

  function isShareToTeacher(mode) {
    return !isShareToGroup(mode);
  }

  var SHARE_MODE = Object.freeze({
    TEACHER: 'teacher',
    GROUP: 'group',
    STUDENT_SMALL_GROUP: 'student_small_group',
    SMALL_GROUP_TEACHER: 'small_group_teacher',
    SMALL_GROUP_GROUP: 'small_group_group',
    GROUP_TEACHER: 'group_teacher',
    GROUP_GROUP: 'group_group',
    getGraphic: function (mode) {
      if (isShareToGroup(mode)) {
        return 'fa-users';
      } else {
        return 'fa-user';
      }
    },
    getSVGPath: function (mode) {
      if (isShareToGroup(mode)) {
        return 'M34.777,13.18c4.021,4.02,4.021,10.538,0,14.557c-4.02,4.021-10.536,4.021-14.557,0 c-4.02-4.02-4.02-10.537,0-14.557C24.241,9.16,30.758,9.16,34.777,13.18z M10.838,19.048c-2.084-0.125-4.071-0.921-5.664-2.272 c-0.813-0.221-1.684-0.01-2.306,0.56c-0.822,0.751-1.004,1.8-1.222,2.867c-0.204,1.002-0.487,2.057-0.734,3.067 c-0.28,1.144-0.568,2.319-0.32,3.474c0.241,1.123,0.95,2.074,1.865,2.769c0.975,0.738,2.124,1.154,3.295,1.35 c1.229,0.205,2.501,0.166,3.744-0.131c0.758-1.087,1.752-1.987,2.907-2.635c1.394-0.779,2.973-1.166,4.568-1.118 c-0.75-1.12-1.287-2.368-1.582-3.683c-0.381-1.693-0.354-3.452,0.077-5.133C14.022,18.839,12.431,19.144,10.838,19.048z  M6.833,5.228c-2.668,2.667-2.668,6.993,0,9.66c2.667,2.668,6.992,2.668,9.66,0c2.668-2.667,2.668-6.993,0-9.66 C13.825,2.56,9.5,2.56,6.833,5.228z M39.533,18.163c0.432,1.681,0.457,3.44,0.078,5.133c-0.297,1.315-0.834,2.563-1.584,3.683 c1.598-0.048,3.176,0.339,4.568,1.118c1.156,0.647,2.15,1.548,2.908,2.635c1.242,0.297,2.516,0.336,3.744,0.131 c1.17-0.195,2.32-0.611,3.295-1.35c0.916-0.694,1.623-1.646,1.865-2.769c0.248-1.154-0.041-2.33-0.32-3.474 c-0.248-1.01-0.529-2.065-0.734-3.067c-0.219-1.067-0.4-2.116-1.221-2.867c-0.623-0.569-1.494-0.781-2.309-0.56 c-1.592,1.351-3.578,2.147-5.664,2.272C42.568,19.144,40.977,18.839,39.533,18.163z M38.506,5.228c-2.666,2.667-2.666,6.993,0,9.66 c2.668,2.668,6.994,2.668,9.662,0c2.666-2.667,2.666-6.993,0-9.66C45.5,2.56,41.174,2.56,38.506,5.228z M46.203,38.663 c-0.373-2.512-1.008-5.105-2.781-7.084c-1.607-1.796-3.957-2.753-6.363-2.595c-2.492,2.438-5.84,3.804-9.327,3.806 c-3.55,0.002-6.954-1.407-9.463-3.918c-2.803-0.166-5.502,1.104-7.161,3.368c-1.464,1.999-1.929,4.442-2.252,6.809 c-0.222,1.628-0.385,3.281-0.483,4.969c-0.062,1.856,0.629,3.66,1.916,5.001c1.207,1.256,2.829,1.994,4.527,2.381 c4.237,0.965,8.582-0.243,12.912-0.285c3.647-0.036,7.327,0.748,10.964,0.443c1.156-0.098,2.283-0.303,3.371-0.725 c1.164-0.453,2.227-1.146,3.035-2.098c0.975-1.148,1.518-2.602,1.533-4.107C46.639,42.599,46.492,40.609,46.203,38.663z';
      } else {
        return 'M27.499,6.697c5.685,0,10.293,4.608,10.293,10.293s-4.608,10.293-10.293,10.293S17.206,22.675,17.206,16.99 S21.814,6.697,27.499,6.697z M46.631,41.159c-0.016,1.506-0.559,2.959-1.533,4.106c-0.809,0.953-1.871,1.646-3.035,2.099 c-1.088,0.422-2.215,0.627-3.371,0.726c-3.637,0.305-7.315-0.479-10.963-0.443c-4.33,0.042-8.675,1.25-12.912,0.285 c-1.698-0.387-3.32-1.125-4.527-2.381c-1.287-1.342-1.979-3.146-1.916-5.002c0.099-1.688,0.262-3.341,0.483-4.969 c0.323-2.365,0.788-4.811,2.252-6.809c1.659-2.266,4.358-3.534,7.161-3.368c2.509,2.511,5.913,3.92,9.463,3.918 c3.487-0.002,6.834-1.367,9.327-3.806c2.406-0.158,4.756,0.799,6.363,2.595c1.773,1.979,2.408,4.571,2.781,7.084 C46.492,37.141,46.639,39.131,46.631,41.159z';
      }
    },
    isUsingSmallGroups: isUsingSmallGroups,
    isShareToTeacher: isShareToTeacher,
    isShareToGroup: isShareToGroup
  });

  return SHARE_MODE;
});

services.factory('GATE_MODE', function () {
  var GATE_MODE = Object.freeze({
    XPGateModeGated: 'gated',
    XPGateModeUngated: 'ungated'
  });

  return GATE_MODE;
});

services.factory('classIdService', ['$q', '$routeParams', function ($q, $routeParams) {
  function getClassId() {
    return $routeParams.classId;
  }

  return getClassId;
}]);

services.factory('IconOverlays',
  function () {

    var whiteBackground = {
      icon: 'ex-circle',
      className: 'icon-overlay-white'
    };

    var redCross = {
      icon: 'remove-sign',
      className: 'icon-overlay-red'
    };

    var greenCheck = {
      icon: 'ok-sign',
      className: 'icon-overlay-green'
    };

    var blueMinus = {
      icon: 'minus-sign',
      className: 'icon-overlay-blue'
    };

    var consts = {
      CHECK: [whiteBackground, greenCheck],
      CROSS: [whiteBackground, redCross],
      MINUS: [whiteBackground, blueMinus]
    };

    return consts;
  });

// window.onfocus and window.onblur
services.factory('windowActivation', ['$rootScope', '$window', 'EventAuditAnalyticsService', '$log', 'User',
  function ($rootScope, $window, EventAuditAnalyticsService, $log, User) {

    $window.onfocus = function (e) {
      let userId = User.getId() || null;
      let confirmation = {
        url: $window.location.href,
        user_id: userId
      };

      let event = $rootScope.$broadcast('onfocus', confirmation);

      // if (userId) {
      //   EventAuditAnalyticsService.save({
      //     url: $window.location.href,
      //     user_id: userId,
      //     event_name: "Screen Focus Start"
      //   }).$promise.then(function () {
      //     $log.info("windowActivation onfocus " + userId);
      //   });
      // } else {
      //   $log.info("windowActivation onfocus nouserid");
      // }

      if (event.defaultPrevented) {
        return confirmation.message;
      }
    };

    $window.onblur = function (e) {
      let userId = User.getId() || null;
      let confirmation = {
        url: $window.location.href,
        user_id: userId
      };

      $rootScope.$broadcast('onblur', confirmation);

      // if (userId) {
      //   EventAuditAnalyticsService.save({
      //     url: $window.location.href,
      //     user_id: userId,
      //     event_name: "Screen Focus End"
      //   }).$promise.then(function () {
      //     $log.info("windowActivation onblur " + userId)
      //   });
      // } else {
      //   $log.info("windowActivation onblur nouserid")
      // }
    };

    return {};
  }])
  .run(function (windowActivation) {
    // Must invoke the service at least once
  });
